import EmptyView from "common/Empty/EmptyView";
import React from "react";
import { FiltersSlice, LanguageNameSpaces, WorkspaceType } from "@shared/types";
import { selectWorkspace } from "@shared/slices/common.slice";
import { useSelector } from "react-redux";
import { getAccountsEmptyData } from "@shared/utils/misc";
import { EmptyStatesType } from "common/Icons/types.ts";
import { useIsSubUser } from "@shared/utils/hooks/misc.ts";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation.ts";

interface AccountsEmptyProps {
  buttonOnClick?: () => void;
  iconWidth?: number;
  isSearch?: boolean;
  hasData?: boolean;
  filtersSlice?: FiltersSlice;
}

const AccountsEmpty = ({
  buttonOnClick,
  iconWidth,
  isSearch,
  hasData,
  filtersSlice,
}: AccountsEmptyProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.COMMON);
  const workspace = useSelector(selectWorkspace);
  const isDemo = workspace === WorkspaceType.DEMO;
  const emptyData = getAccountsEmptyData(t, isDemo);
  const isSubUser = useIsSubUser();

  return (
    <EmptyView
      iconKey={EmptyStatesType.Connect}
      title={emptyData.title}
      description={emptyData.description}
      buttonText={isSubUser ? undefined : emptyData.buttonText}
      buttonOnClick={buttonOnClick}
      iconWidth={iconWidth}
      objectName={t("empty.accounts")}
      isSearch={isSearch}
      hasData={hasData}
      filtersSlice={filtersSlice}
    />
  );
};

export default AccountsEmpty;
